import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { getBreadcrumbs } from '@plone/volto/actions/breadcrumbs/breadcrumbs';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import homeSVG from '@plone/volto/icons/home.svg';

const messages = defineMessages({
  home: { id: 'Home', defaultMessage: 'Início' },
  breadcrumbs: { id: 'Breadcrumbs', defaultMessage: 'Trilha de navegação' },
});

const BreadcrumbsComponent = ({ pathname }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname: realPath } = useLocation();
  const items = useSelector(
    (state) => state.breadcrumbs.items,
    shallowEqual,
  );

  useEffect(() => {
    if (!hasApiExpander('breadcrumbs', getBaseUrl(pathname))) {
      dispatch(getBreadcrumbs(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  // Esconde breadcrumbs na home (root path)
  if (realPath === '/' || realPath === '') return null;
  if (!items || items.length === 0) return null;

  return (
    <nav className="ag-breadcrumbs" aria-label={intl.formatMessage(messages.breadcrumbs)}>
      <div className="ag-breadcrumbs__inner">
        <Breadcrumb>
          <Link
            to="/"
            className="section ag-breadcrumbs__home"
            title={intl.formatMessage(messages.home)}
          >
            <Icon name={homeSVG} size="14px" />
          </Link>
          {/* Em páginas fundas, omite o último item (página atual): o título
              completo é redundante com o H1 logo abaixo, a trilha termina no pai.
              Em páginas de 1º nível (só 1 item), mantém — senão sobra só a casa. */}
          {(items.length > 1 ? items.slice(0, -1) : items).map((item) => (
            <React.Fragment key={item.url}>
              <Breadcrumb.Divider>›</Breadcrumb.Divider>
              <Link to={item.url} className="section">
                {item.title}
              </Link>
            </React.Fragment>
          ))}
        </Breadcrumb>
      </div>
    </nav>
  );
};

BreadcrumbsComponent.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default BreadcrumbsComponent;
